import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_API_URL}`;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper: Check if token is expired
function isTokenExpired(token) {
  if (!token) return true;
  try {
    const [, payload] = token.split('.');
    const decoded = JSON.parse(atob(payload));

    // Optional logs
    // console.log('Decoded JWT payload:', decoded);
    const expiry = new Date(decoded.exp * 1000);
    console.log('Token expires at:', expiry.toLocaleString());

    const now = Math.floor(Date.now() / 1000);
    return decoded.exp < now;
  } catch (e) {
    console.error('Failed to decode token', e);
    return true;
  }
}

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      // Check expiration
      if (isTokenExpired(token)) {
        console.warn('Token expired. Logging out...');
        localStorage.clear();
        window.location.reload();
        return Promise.reject(new Error('Token expired'));
      }

      // Attach token
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Login
export const loginWithUserId = (id) => {
  return api.post('/login', { user_id: id });
};

// add sample maker
export const handleUpdateUser = (user) => {
  return api.put('/update_maker', user); // must include headers (token)
};

export const handleAddUser = (user) => {
  return api.post('/create_sample_maker', user);
};
export const handleLineNumber = (data) => {
  return api.post('/tsd_other_settings', data);
};
export const handleDeleteUser = (user, config) => {
  return api.put('/delete_recover_maker', user, config);
};
export const handleRecoverMaker = (user, config) => {
  return api.put('/delete_recover_maker', user, config);
};
export const handleTsdLogs = (data, config) => {
  return api.post('/tsd_settings_logs', data, config);
};

export const getTsdSettingsAPI = async ({ per_page, page, type, search }) => {
  return await api.post('/get_tsd_settings', {
    per_page,
    page,
    type,
    search
  });
};

export default api;